import { MapPin, Phone, Mail, Clock } from "lucide-react";

const footerSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://afromagicbraiding.shop/#footer-local-business",
  "name": "Afro Magic Braiding Hair",
  "description": "Best hair braiding in Southfield Michigan. Premium African hair braiding salon specializing in knotless braids, box braids, cornrows, and protective styles.",
  "url": "https://afromagicbraiding.shop",
  "telephone": "(313) 484-7307",
  "email": "booking@afromagicbraiding.shop",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "22560 Telegraph Rd",
    "addressLocality": "Southfield",
    "addressRegion": "MI",
    "postalCode": "48033",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 42.4734,
    "longitude": -83.2219
  },
  "hasMap": "https://www.google.com/maps?q=22560+Telegraph+Rd,+Southfield,+MI+48033",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    }
  ],
  "priceRange": "$50-$240"
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="border-t border-brand-border py-12"
      data-testid="footer"
      itemScope
      itemType="https://schema.org/LocalBusiness"
    >
      {/* Local Business JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(footerSchema) }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8">
          {/* Brand + Address */}
          <div>
            <a
              href="#hero"
              className="flex items-center gap-3"
              data-testid="footer-logo"
              aria-label="Afro Magic Braiding Hair"
            >
              <img
                src="/logos/v3_circle_crest.png"
                alt="Afro Magic Braiding Hair crest"
                className="h-14 w-14 object-contain"
              />
              <span className="font-serif text-base font-semibold text-brand-text leading-tight">
                <span itemProp="name">Afro <span className="text-brand-gold">Magic</span> Braiding Hair</span>
              </span>
            </a>
            <p className="font-sans text-xs text-brand-text-muted mt-1">
              Best Hair Braiding in Southfield Michigan
            </p>
            <div
              className="mt-3 space-y-1.5"
              itemProp="address"
              itemScope
              itemType="https://schema.org/PostalAddress"
            >
              <p className="font-sans text-xs text-brand-text-muted flex items-center gap-2" data-testid="footer-address">
                <MapPin size={12} className="text-brand-gold flex-shrink-0" />
                <span>
                  <span itemProp="streetAddress">22560 Telegraph Rd</span>,{" "}
                  <span itemProp="addressLocality">Southfield</span>,{" "}
                  <span itemProp="addressRegion">MI</span>{" "}
                  <span itemProp="postalCode">48033</span>
                </span>
              </p>
              <p className="font-sans text-xs text-brand-text-muted flex items-center gap-2" data-testid="footer-phone">
                <Phone size={12} className="text-brand-gold flex-shrink-0" />
                <a href="tel:+13134847307" itemProp="telephone" className="hover:text-brand-gold transition-colors">(313) 484-7307</a>
              </p>
              <p className="font-sans text-xs text-brand-text-muted flex items-center gap-2" data-testid="footer-email">
                <Mail size={12} className="text-brand-gold flex-shrink-0" />
                <a href="mailto:booking@afromagicbraiding.shop" itemProp="email" className="hover:text-brand-gold transition-colors">booking@afromagicbraiding.shop</a>
              </p>
              <p className="font-sans text-xs text-brand-text-muted flex items-center gap-2" data-testid="footer-hours">
                <Clock size={12} className="text-brand-gold flex-shrink-0" />
                <span>Open 6 AM - 9 PM &middot; 7 days a week</span>
              </p>
            </div>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap items-center gap-6" data-testid="footer-nav">
            {["Services", "Gallery", "Reviews", "Booking", "Contact"].map(
              (link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  className="font-sans text-xs text-brand-text-muted hover:text-brand-gold transition-colors tracking-wide"
                  data-testid={`footer-link-${link.toLowerCase()}`}
                >
                  {link}
                </a>
              )
            )}
            <a href="/consent-policy" className="font-sans text-xs text-brand-text-muted hover:text-brand-gold transition-colors tracking-wide" data-testid="footer-link-privacy">Privacy Policy</a>
          </nav>

          {/* Copyright */}
          <p className="font-sans text-xs text-brand-text-muted/60">
            &copy; {currentYear} Afro Magic Braiding Hair
          </p>
          <p className="font-sans text-[10px] text-brand-text-muted/40 mt-1">
            Afro Magic Braiding is a trade name of HY SERVICES LLC.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
